import { Box, Button, FormControlLabel, Grid, Switch, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import {
  getPaymentSettingsReq,
  PaymentSettingsResult,
  updatePaymentSettingsReq,
} from "../app/services/payment-settings.service";
import LoadingIndicator from "../app/components/loading-indicator";

export default function PaymentSettingsView() {
  const [settings, setSettings] = useState<PaymentSettingsResult | null>(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    getPaymentSettingsReq()
      .then(setSettings)
      .finally(() => setLoading(false));
  }, []);

  const handleSave = async () => {
    if (!settings) return;
    setSaving(true);
    try {
      const updated = await updatePaymentSettingsReq({
        processors: settings.processors,
        defaultProcessor: settings.defaultProcessor,
      });
      setSettings(updated);
    } finally {
      setSaving(false);
    }
  };

  if (!settings) {
    return <LoadingIndicator open={loading} />;
  }

  return (
    <Box p={2}>
      <LoadingIndicator open={loading || saving} />
      <Typography variant="h5" mb={2}>
        Configuración de pagos
      </Typography>
      <Grid container spacing={2} maxWidth={600}>
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Switch
                checked={settings.processors.wompi.enabled}
                onChange={(e) =>
                  setSettings({
                    ...settings,
                    processors: {
                      ...settings.processors,
                      wompi: { enabled: e.target.checked },
                    },
                  })
                }
              />
            }
            label="Wompi (Colombia - tarjeta)"
          />
          <Typography variant="caption" display="block" color="text.secondary">
            {settings.envStatus?.wompiConfigured
              ? "Claves Wompi configuradas en el servidor"
              : "Wompi público se configura en el frontend (VITE_WOMPI_*)"}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Switch
                checked={settings.processors.blockbee.enabled}
                onChange={(e) =>
                  setSettings({
                    ...settings,
                    processors: {
                      ...settings.processors,
                      blockbee: { enabled: e.target.checked },
                    },
                  })
                }
              />
            }
            label="BlockBee (Criptomonedas)"
          />
          <Typography variant="caption" display="block" color="text.secondary">
            {settings.envStatus?.blockbeeConfigured
              ? "BLOCKBEE_API_KEY configurada en el servidor"
              : "Falta BLOCKBEE_API_KEY en el backend"}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Button variant="contained" onClick={handleSave} disabled={saving}>
            Guardar
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}
